import React from 'react';
import { Grid, Typography } from '@mui/material';
import { listStyles } from './section-list-with-search-field-component-helper';

interface SectionListSearchEmptyProps {
    searchEmptyHeadingText: string;
    searchEmptySubHeadingText: string;
}

export const SectionListSearchEmpty = ({
    searchEmptyHeadingText,
    searchEmptySubHeadingText,
}: SectionListSearchEmptyProps): React.JSX.Element => {
    return (
        <Grid sx={listStyles.emptyContainerStyles}>
            <Typography sx={listStyles.errorHeaderTextStyles}>
                {searchEmptyHeadingText}
            </Typography>
            <Typography sx={listStyles.textStyles}>
                {searchEmptySubHeadingText}
            </Typography>
        </Grid>
    );
};
